import React, { Component } from "react";

import { Button, Modal, Popconfirm } from "antd";
import { Tabs } from "antd";
import { message } from "antd";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import instance from "@/store/actions/instance";
import PurchaseOrderInvoice from "./PurchaseOrderInvoice";

const { TabPane } = Tabs;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

class PurchaseOrderDetailsModal extends Component {
  state = {
    loading: true,
    isReceiving: false,
    products: [],
    editMode: false,
    originalProducts: [],
  };
  fetchPurchaseOrderDetails = async () => {
    const { t, selectedOrder } = this.props;
    try {
      const res = await instance.get(`get_purchase_orders/${selectedOrder.id}`);

      this.setState({
        loading: false,
        products: res.data,
        originalProducts: res.data.map((e) => {
          //To have a new reference
          return { ...e };
        }),
      });
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
  };

  updatePurchaseOrder = async () => {
    const { t, selectedOrder } = this.props;
    const { products } = this.state;
    try {
      this.setState({ loading: true });

      const res = await instance.post(`update_purchase_order/`, {
        orderId: selectedOrder.id,
        products: products,
      });
      selectedOrder.total = res.data.total;
      selectedOrder.status = res.data.status;
      const savedProducts = res.data.products || [];
      this.setState({
        loading: false,
        editMode: false,
        products: savedProducts,
        originalProducts: savedProducts.map((product) => ({ ...product })),
      });
      message.success(t("Changed successfully"));
    } catch (err) {
      this.setState({
        loading: false,
      });
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(err.response?.data?.error || t("SomethingWentWrong"));
    }
  };
  updatePurchaseOrderStatus = async (newStatus) => {
    const { t, selectedOrder } = this.props;
    const { products } = this.state;
    try {
      this.setState({ loading: true });

      const res = await instance.post(`change_purchase_order_status/`, {
        oid: selectedOrder.id,
        newValue: newStatus,
        type: "status",
        products,
      });

      selectedOrder.status = res.data.status;
      selectedOrder.received_total = res.data.received_total;
      await this.fetchPurchaseOrderDetails();
      this.setState({
        loading: false,
        isReceiving: false,
      });
      message.success(t("Changed successfully"));
    } catch (err) {
      this.setState({
        loading: false,
      });
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(err.response?.data?.error || t("SomethingWentWrong"));
    }
  };
  setEditMode = (newEditMode) => {
    this.setState({ editMode: newEditMode });
  };
  setProducts = (newProducts) => {
    this.setState({ products: newProducts });
  };
  componentDidMount = () => {
    this.fetchPurchaseOrderDetails();
  };
  render() {
    const { t, config, selectedOrder, permissions, isViewOnly } = this.props;
    const { loading, products, editMode, originalProducts, isReceiving } =
      this.state;
    return (
      <Modal
        maskClosable={false}
        destroyOnClose={true}
        title={
          <div
            className="ant-modal-title"
            style={{ textAlign: config.direction == "rtl" ? "right" : "left" }}
          >
            {t("Order details")}
          </div>
        }
        open={true}
        cancelText={t("Close")}
        okButtonProps={{
          style: {
            display: "none",
          },
        }}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
        width={1000}
        onCancel={this.props.onClose}
        footer={[
          !loading && !isViewOnly && (
            <>
              {!editMode ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {permissions.can_create_purchase_orders && (
                    <Button
                      onClick={() =>
                        this.props.duplicateOrder({
                          products: products,
                          order: selectedOrder,
                        })
                      }
                      style={{
                        margin: 5,
                      }}
                    >
                      {t("Reorder")}
                    </Button>
                  )}
                  {selectedOrder.status == "Pending Approval" &&
                    permissions.can_approve_purchase_orders && (
                      <div style={{ display: "flex" }}>
                        <Button
                          type="danger"
                          onClick={() =>
                            this.updatePurchaseOrderStatus("Rejected")
                          }
                          style={{ margin: "5px" }}
                        >
                          {t("Reject")}
                        </Button>
                        <Button
                          type="primary"
                          onClick={() =>
                            this.updatePurchaseOrderStatus("Approved")
                          }
                          style={{ margin: "5px" }}
                        >
                          {t("Approve")}
                        </Button>
                      </div>
                    )}

                  {selectedOrder.status == "Draft" &&
                    permissions.can_create_purchase_orders && (
                      <Button
                        type="primary"
                        onClick={() =>
                          this.updatePurchaseOrderStatus("Pending Approval")
                        }
                        style={{ margin: "5px" }}
                      >
                        {t("Submit for approval")}
                      </Button>
                    )}
                  {["Approved", "Partial"].includes(selectedOrder.status) &&
                    permissions.can_receive_purchase_orders &&
                    !isReceiving && (
                      <div>
                        {selectedOrder.status === "Partial" && (
                          <Popconfirm
                            title={t(
                              "The order can no longer be edited after it's closed",
                            )}
                            onConfirm={
                              () =>
                                this.updatePurchaseOrderStatus(
                                  "Partialy Closed",
                                )
                              // this.setState({ isReceiving: true })
                            }
                            okText={t("Close")}
                            cancelText={t("Close")}
                          >
                            <Button type="danger" style={{ margin: "5px" }}>
                              {t("Close")}
                            </Button>
                          </Popconfirm>
                        )}
                        <Button
                          type="primary"
                          style={{ margin: "5px" }}
                          onClick={() => this.setState({ isReceiving: true })}
                        >
                          {t("Receive")}
                        </Button>
                      </div>
                    )}
                  {isReceiving && (
                    <div>
                      <Popconfirm
                        title={t(
                          "Receiving this purchase order will update the stock and the cost",
                        )}
                        onConfirm={
                          () => this.updatePurchaseOrderStatus("Received")
                          // this.setState({ isReceiving: true })
                        }
                        okText={t("Receive")}
                        cancelText={t("Close")}
                      >
                        <Button type="primary" style={{ margin: "5px" }}>
                          {t("Receive Fully")}
                        </Button>
                      </Popconfirm>
                      <Popconfirm
                        title={t(
                          "Receiving this purchase order will update the stock and the cost",
                        )}
                        onConfirm={
                          () => this.updatePurchaseOrderStatus("Partial")
                          // this.setState({ isReceiving: true })
                        }
                        okText={t("Receive")}
                        cancelText={t("Close")}
                      >
                        <Button type="primary" style={{ margin: "5px" }}>
                          {t("Receive as typed")}
                        </Button>
                      </Popconfirm>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    type="danger"
                    onClick={() => {
                      this.setState({
                        products: originalProducts.map((e) => {
                          //To have a new reference
                          return { ...e };
                        }),
                      });
                      this.setEditMode(false);
                    }}
                    style={{
                      margin: 5,
                    }}
                  >
                    {t("Cancel Updates")}
                  </Button>

                  <Button
                    type="primary"
                    onClick={() => this.updatePurchaseOrder()}
                    style={{ margin: "5px" }}
                  >
                    {t("Update")}
                  </Button>
                </div>
              )}
            </>
          ),
        ]}
      >
        {loading ? (
          <div className="my-5 text-center">
            <Spin indicator={antIcon} />
          </div>
        ) : (
          <>
            <PurchaseOrderInvoice
              editMode={editMode}
              isReceiving={isReceiving}
              setEditMode={this.setEditMode}
              setProducts={this.setProducts}
              selectedOrder={selectedOrder}
              products={products}
              isViewOnly={isViewOnly}
              fetchPurchaseOrderDetails={this.fetchPurchaseOrderDetails}
            />
          </>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(PurchaseOrderDetailsModal));
